import { Component } from "react";
import {Card, Form, Button, Row, Col, Alert} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';

class GruposEdit extends Component {
    constructor(props) {
        super(props);
        this.onChangeNome = this.onChangeNome.bind(this);        
        this.enviaGrupo = this.enviaGrupo.bind(this);

        this.state = {
            nome: "",            
            erroLoadGru: "",
            grupo_id: "",
            titulo_pagina: "",
            loading: false,
        };
    }

    componentDidMount(){
        const id = this.props.router.params.id;

        if(id){
            this.setState({
                grupo_id: id,
                titulo_pagina: 'Editando grupo',
                loading: true,
                erroLoadGru: ''
            })

            //consulta os dados do cliente na api
            api.get(`/grupos/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadGru: '',
                    nome: dados.name,                    
                    loading: false
                })

                //permissoes
                this.setState({
                    permissoes: dados.permissoes_list.map(this.mapResponseToValuesAndLabels)
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar grupo, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadGru: erro_msg,
                })
            });
        }
        else {
            this.setState({
                grupo_id: '',
                titulo_pagina: 'Adicionar grupo',
                loading: false,
                erroLoadGru: '',
            })
        }
    }

    enviaGrupo = (e) => {
        e.preventDefault();

        this.setState({
            loading: true,
            nomeHelper: '',           
        });

        //vererifica se é edição ou adição
        const url = (this.state.grupo_id) ? '/grupos/'+this.state.grupo_id+'/' : '/grupos/'
        const metodo = (this.state.grupo_id) ? 'put' : 'post'

        //permissoes
        let perm_list = [];
        for (let key in this.state.permissoes){
            const perm = this.state.permissoes[key]
            perm_list.push(perm.value)
        }
        
        //envia para api
        api({
            method: metodo,
            url: url,
            data: {
                'name': this.state.nome,     
                'permissoes': perm_list          
            }
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.grupo_id) ? 'Grupo atualizado com sucesso' : 'Grupo cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.grupo_id){
                this.props.router.navigate("/grupos");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar grupo, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'nome'){
                        this.setState({
                            nomeHelper: value,
                        })
                    }                    
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    onChangeNome = (e) => {            
        this.setState({
            nome: e.target.value,
        })
    };

    mapResponseToValuesAndLabels = (data) => ({
        value: data.id,
        label: data.name,
    });

    buscaUserPermissoes = async (busca) => {        
        try {
            const {data:response} = await api.get(`/permissoes/?busca=${busca}`)
            const results = response.results;

            return results.map(this.mapResponseToValuesAndLabels)
        }
          
        catch (error) {
            console.error(error);
            
            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>Erro ao consultar permissões, tente novamente</p>,
            })  
        }
    }

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Form method="get" onSubmit={this.enviaGrupo}>
                    <Card className="cardDestaque">
                        <Card.Body>                                            
                            <Row>
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control type="text" required placeholder="Nome" name="nome" id="formNome" value={this.state.nome} onChange={this.onChangeNome} />                            
                                        <Form.Text id="formNomeHelpBlock" className="text-danger">{this.nomeHelper}</Form.Text>
                                    </Form.Group>
                                </Col>                                
                            </Row>  
                            {this.state.erroLoadGru ? 
                            <Alert variant="warning">
                                {this.state.erroLoadGru}
                            </Alert> : ''
                            }
                        </Card.Body>                
                    </Card>

                    <Card className="cardDestaque mt-3">
                        <Card.Body>      
                            <h4>Permissões</h4>                                      
                            <Row>
                                <Col xs={12}>
                                    <Form.Group className="mb-3">
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={this.buscaUserPermissoes}
                                            onChange={(data) => {
                                                this.setState({
                                                    permissoes: data
                                                });
                                            }}
                                            value={this.state.permissoes}
                                            isMulti
                                            defaultOptions
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    <div className="text-center">
                        <Button type="submit" className="btn btn-first mt-3" disabled={this.state.loading}>
                            {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Salvar'}                                       
                        </Button>     
                    </div>
                </Form>
            </div>
        )
    }
}

export default withRouter(GruposEdit);